"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/@stardust-ui/react-component-event-listener/dist/commonjs/types.js
// module id = 1050
// module chunks = 0